import toast from 'react-hot-toast';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { sendErrorReport } from '../../shared/utilities/sendErrorReport';

import * as actions from './actions';
import * as api from './api';
import { NormalizedInTripReview, RemoveInTripReviewAction } from './types';
import { removeInTripReviewFromCache } from './cache-utils';

function* getInTripReviewsFlow(): SagaIterator {
    try {
        const apiResponse: NormalizedInTripReview = yield call(api.fetchInTripReviews);
        yield put(actions.getInTripReviewsSuccess(apiResponse));
    } catch (e) {
        yield put(actions.getInTripReviewsFailure((e as Error).message));
        sendErrorReport(e as Error);
    }
}

function* removeInTripReviewFlow({ dossierId }: RemoveInTripReviewAction) {
    try {
        yield call(api.patchRemoveInTripReview, dossierId);

        // TODO: Move that to mutation cache update once inTripReview gets migrated to react-query
        removeInTripReviewFromCache(dossierId);
        yield put(actions.removeInTripReviewSuccess());
        toast.success('dossier.in_trip_review.notifications.success');
    } catch (e) {
        yield put(actions.removeInTripReviewFailure((e as Error).message));
        toast.error('dossier.in_trip_review.notifications.error');
        sendErrorReport(e as Error);
    }
}

export function* getInTripReviewsRequestWatcher(): SagaIterator {
    yield takeLatest(actions.fetchInTripReviewsRequestAction, getInTripReviewsFlow);
    yield takeLatest(actions.removeInTripReviewAction, removeInTripReviewFlow);
}
